import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MonitorTab, MonitorTabId } from './device-monitor-tabs';

@Component({ selector: 'app-device-monitor-sdwan', templateUrl: './device-monitor-sdwan.component.html',
  styleUrls: ['./device-monitor-sdwan.component.scss'] })
export class DeviceMonitorSdwanComponent {
  @Input() device!: any[];
  @Input() role!: number;
  @Input() tabs: ReadonlyArray<MonitorTab> = [];
  @Input() activeId!: MonitorTabId;
  @Output() tabSelected = new EventEmitter<MonitorTabId>();
}
